import { render, staticRenderFns } from "./NovaSolicitacaoAutorizacao.vue?vue&type=template&id=74307396&scoped=true&"
import script from "./NovaSolicitacaoAutorizacao.vue?vue&type=script&lang=js&"
export * from "./NovaSolicitacaoAutorizacao.vue?vue&type=script&lang=js&"
import style0 from "./NovaSolicitacaoAutorizacao.vue?vue&type=style&index=0&id=74307396&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74307396",
  null
  
)

export default component.exports